import { useAccount } from 'wagmi';
import { Network } from '@kattana-io/common';
import NetworkSelectorCore from './core';
import useChangeNetwork from '../../hooks/useChangeNetwork';

import './styles.scss';

interface INetworkSelectorProps {
  textSize?: 16 | 14;
  textWeight?: '400' | '500' | '600';
  imageSize?: 'l' | 'm';
}

const NetworkSelector = ({
  textSize = 14,
  textWeight = '600',
  imageSize = 'm',
}: INetworkSelectorProps) => {
  const { address } = useAccount();
  const { networkId, loading, changeNetwork } = useChangeNetwork();

  const onClick = (id: number) => {
    changeNetwork(id);
  };

  if (!networkId || !address) {
    return null;
  }

  return (
    <NetworkSelectorCore
      textSize={textSize}
      textWeight={textWeight}
      imageSize={imageSize}
      onClickCallback={onClick}
      currentNetwork={Network.fromChainId(networkId)}
      loading={loading}
    />
  );
};

export default NetworkSelector;
